import { useNavigate, useParams } from "react-router-dom";
import { isLogin } from "../../../utils";
import { TopBar } from "../../../widgets";
import { useEffect, useState } from "react";
import { getWellnessLectureDetailByWellnessLectureId } from "../../../service/wellnessLecture";
import { Button, Checkbox, Flex, Input, Modal, Rate, Tag, message } from "antd";
import ImageUploader from "../ui/ImageUploader";
import { deleteWellnessLectureReview, getWellnessLectureReviewByWellnessLectureId, updateWellnessLectureReview } from "../../../service/wellnessLectureReview";
import dayjs from "dayjs";
import { ReactComponent as Trash } from "../../../assets/images/icon/trash.svg";
import { ReactComponent as Star } from "../../../assets/images/icon/star.svg";
import { SolidBtn } from "../../../shared";
import { CheckCircleFilled, CheckCircleOutlined } from "@ant-design/icons";
import './index.css'
import { isIOS } from "react-device-detect";

const { TextArea } = Input;

const UpdateReview = () => {
    const navigate = useNavigate();
    const { wellnessLectureId } = useParams();
    const [wellnessLecture, setWellnessLecture] = useState<IWellnessLectureDetailWebResponseV2>();
    const [selectedTags, setSelectedTags] = useState<string[]>([]);
    const [uploadedUrls, setUploadedUrls] = useState<Array<string>>([]);
    const [content, setContent] = useState<string | undefined>(undefined);
    const [rating, setRating] = useState<number | undefined>(undefined);
    const [isPrivate, setIsPrivate] = useState<boolean>(false);
    const [wellnessLectureReviewId, setWellnessLectureReviewId] = useState<number | undefined>(undefined);
    const [imageUrlList, setImageUrlList] = useState<Array<string>>([]);
    const [deleteOpen, setDeleteOpen] = useState<boolean>(false);
    const [isExpire, setIsExpire] = useState<boolean>(false);

    const onDeleteClick = () => {
        if (!wellnessLectureReviewId) return;
        deleteWellnessLectureReview(wellnessLectureReviewId.toString())
            .then(res => navigate(-1))
            .catch(err => console.error('err', err))
    }

    const handleClick = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        if (!wellnessLectureId) return;
        if (!wellnessLectureReviewId) return message.error("리뷰가 존재하지 않습니다.");
        if (!rating) return message.error("별점을 입력해주세요.");

        const params = {
            id: wellnessLectureReviewId,
            rating: rating,
            content: content ?? '',
            wellnessLectureId: Number(wellnessLectureId),
            reviewCategoryList: selectedTags,
            imageUrlList: uploadedUrls,
            isPrivate: isPrivate
        }
        updateWellnessLectureReview(params)
            .then(res => {
                if (res.data === true) {
                    navigate(-1);
                }
                else {
                    message.error('서버에서 에러가 발생했습니다.');
                }
            })
            .catch(err => console.error('err', err))
    }

    useEffect(() => {
        if (!isLogin()) {
            navigate("/login")
            return;
        }
        if (!wellnessLectureId) return;

        getWellnessLectureDetailByWellnessLectureId(wellnessLectureId)
            .then(res => setWellnessLecture(res.data))
            .catch(err => console.error('err', err))

        getWellnessLectureReviewByWellnessLectureId(wellnessLectureId)
            .then(res => {
                const review = res.data;
                setWellnessLectureReviewId(review.id);
                setRating(review.rating);
                setSelectedTags(review.reviewCategoryList);
                setContent(review.content);
                setIsPrivate(review.isPrivate);
                setImageUrlList(review.imageUrlList)
                setUploadedUrls(review.imageUrlList)
            })
            .catch(err => console.error('err', err))
    }, [])
    useEffect(() => {
        if (!wellnessLecture) return;
        setIsExpire(dayjs(wellnessLecture.wellnessLectureStartDateTime).add(14, 'day').isBefore(dayjs()))
    }, [wellnessLecture])

    return <>
        <TopBar title="리뷰 수정" rightIcon={false} position='fixed' thema='dark' />
        <div style={{ padding: 20 }}>
            {wellnessLecture && <>
                <div>

                    <div style={{ textAlign: 'center' }}>
                        <div style={{ width: 56, height: 56, margin: '0 auto' }}>
                            <img src={wellnessLecture.wellnessLectureImageUrl || `https://img.positivehotel.io/2024/12/17/LectureDetailDefault.webp`} alt="수업사진" width={'100%'} style={{ borderRadius: "999px", aspectRatio: 1, objectFit: 'cover' }} />
                        </div>
                        <div>
                            <div className="body/b1 secondary/s500" style={{ marginTop: 8 }}>{dayjs(wellnessLecture.wellnessLectureStartDateTime).format('YYYY.MM.DD (dd) HH:mm')}</div>
                            <div className="sub-title/st4" style={{ marginTop: 8, wordBreak: 'keep-all' }}>{wellnessLecture.wellnessLectureName} <br />어떠셨나요?</div>

                        </div>
                    </div>
                    <div style={{ marginTop: 16, textAlign: 'center' }}>
                        <div>
                            <Rate
                                className="custom-rate"
                                disabled={isExpire}
                                style={{ fontSize: 40 }}
                                value={rating}
                                character={({ index = 0 }) => <Star width={48} height={48} fill={(rating ?? 0) <= index ? 'var(--secondarys200)' : "var(--primaryp600)"} />}
                                onChange={(value) => setRating(value)} />
                        </div>
                    </div>

                    <div style={{ marginTop: 32 }}>
                        {isExpire
                            ? <div className="body/b2 base/black" style={{ whiteSpace: 'pre-wrap' }}>{content}</div>
                            : <TextArea
                                className="custom-input-textarea"
                                onClear={() => { }}
                                showCount
                                maxLength={300}
                                onChange={(e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => setContent(e.target.value)}
                                placeholder="좋았던 경험, 혹은 아쉬웠던 점이 있다면 편하게 말씀해주세요."
                                value={content}
                                style={{ height: 148, resize: 'none' }}
                            />}
                    </div>

                    <div style={{ marginTop: 32, marginInline: -20 }}>
                        <ImageUploader setUploadedUrls={setUploadedUrls} imageUrlList={imageUrlList} isDisabled={isExpire} listType={'text'} styles={{ uploadSelect: { marginLeft: 20 } }} />
                    </div>

                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: isExpire ? 'auto' : 'pointer', marginTop: 20 }} onClick={() => !isExpire && setIsPrivate(curr => !curr)}>
                        {isPrivate
                            ? <CheckCircleFilled style={{ fontSize: '16px', color: isExpire ? 'var(--secondarys200)' : 'var(--baseblack)' }} />
                            : <CheckCircleOutlined style={{ fontSize: '16px', color: isExpire ? 'var(--secondarys200)' : 'var(--secondarys400)' }} />
                        }
                        <div className="body/b2 secondary/s800">코치 비공개로 작성하기</div>
                    </div>

                    <div style={{ marginTop: 24, marginBottom: isIOS ? 26 : 0 }}>
                        {isExpire === false && <Button className="sub-title/st3 secondary/s600" style={{ width: '100%', height: '50px', border: '1px solid var(--secondarys400)', borderRadius: 4 }} onClick={handleClick}>수정 하기</Button>}
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 4, marginTop: 20 }} onClick={() => setDeleteOpen(true)}>
                            <div className="sub-title/st2 secondary/s500" style={{ cursor: 'pointer' }} >리뷰 삭제</div>
                            <Trash stroke="var(--secondarys400)" width={16} height={16} style={{ color: 'red' }} />
                        </div>
                    </div>
                </div>
            </>}
        </div >
        <Modal centered styles={{ content: { width: 'auto', marginInline: 12, padding: '20px 16px', borderRadius: 4 } }} open={deleteOpen} onCancel={() => setDeleteOpen(false)} closeIcon={null} footer={null}>
            <div>
                <div style={{ textAlign: 'center' }}>
                    <div className="sub-title/st5 base/black" >
                        리뷰 삭제
                    </div>
                    <div className="body/b2 secondary/s800" style={{ marginTop: 8 }}>
                        작성한 리뷰를 삭제하시겠습니까?
                    </div>
                </div>
                <div style={{ display: 'flex', gap: 16, justifyContent: 'center', marginTop: 16 }}>
                    <SolidBtn type='line' style={{ width: '100%', border: 'solid 1px var(--secondarys400)', color: 'var(--secondarys600)' }} icon={false} onClick={() => setDeleteOpen(false)}>
                        돌아가기
                    </SolidBtn>
                    <SolidBtn type='solid' style={{ width: '100%' }} icon={false} onClick={onDeleteClick}>
                        리뷰 삭제
                    </SolidBtn>
                </div>
            </div>
        </Modal>

    </>
}

export default UpdateReview;